import {
	UseQueryOptions,
	QueryKey,
	useQuery,
	useMutation,
	UseMutationOptions,
	useQueryClient,
} from '@tanstack/react-query'
import {KeycloakUser, WorkspaceProfile} from 'types'

import {switchWorkspace} from './workspaceApi'
import {
	CURRENT_WORKSPACE,
	getCurrentWorkspaceOptions,
	WORKSPACE_QUERY_KEY,
} from './workspaceQueryOptions'

export const useGetCurrentWorkspace = (
	options?: UseQueryOptions<
		WorkspaceProfile,
		Error,
		WorkspaceProfile,
		QueryKey
	>,
) => {
	return useQuery<WorkspaceProfile, Error>(getCurrentWorkspaceOptions(options))
}

export const useSwitchWorkspace = (
	options?: UseMutationOptions<
		KeycloakUser,
		Error,
		{workspace: string},
		unknown
	>,
) => {
	const queryClient = useQueryClient()
	return useMutation<KeycloakUser, Error, {workspace: string}>({
		mutationFn: (data: {workspace: string}) => {
			return switchWorkspace(data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [WORKSPACE_QUERY_KEY, CURRENT_WORKSPACE],
			})
		},
		...options,
	} as UseMutationOptions<KeycloakUser, Error, {workspace: string}>)
}
